import { useEffect } from 'react';
import Cookies from 'js-cookie';

import { loadScript, scriptAlreadyLoaded } from '../script';

interface UseGoogleTagManagerProps {
  gaID?: string;
  gaOptimizeID?: string;
  gaMeasurementID?: string;
  gawConversionID?: string;
  gawSignupConversionLabel?: string;
  gtagID?: string;
  loadAfterLoadEvent?: boolean;
}

const SCRIPT_ID = 'g-tag-manager';

/**
 * Load google tag manager
 * (if already did, then do nothing)
 * to replace `GoogleTagManagerScript`
 * Notice: this will push the script loading later
 *
 * Important notice: to add or modify scripts, use GTM web dashboard
 */
export const useGoogleTagManager = (props?: UseGoogleTagManagerProps) => {
  const {
    gaOptimizeID = process.env.NEXT_PUBLIC_GA_OPTIMIZE_ID,
    gaMeasurementID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID,
    gawConversionID = process.env.NEXT_PUBLIC_GAW_CONVERSION_ID,
    gawSignupConversionLabel = process.env.NEXT_PUBLIC_GAW_CONVERSION_LABEL,
    gtagID = process.env.NEXT_PUBLIC_GTAG_ID,
    loadAfterLoadEvent,
  } = props || {};
  useEffect(() => {
    if (gaOptimizeID && !scriptAlreadyLoaded(SCRIPT_ID)) {
      // from original script
      (function (window, d, l) {
        window[l] = window[l] || [];
        window[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      })(window, document, 'dataLayer');

      window.gtag = function (...args) {
        window.dataLayer && window.dataLayer.push(arguments);
      };

      /* Google Analytics is stopped service */
      // // Google Analytics (Old, Web-only property)
      // if (gaID) {
      //   // GTM already loads this js, so don't call `gtag` to load it again
      //   // window.gtag('config', gaID);
      //   window.gaID = gaID;
      // }

      // Google Ads
      if (gawConversionID) {
        // GTM already loads this js, so don't call `gtag` to load it again
        // window.gtag('config', gawConversionID);
        window.gawConversionID = gawConversionID;
        window.gawSignupConversionLabel = gawSignupConversionLabel;

        /**
         * Get the gclid and save to cookie
         * https://developers.google.com/tag-platform/gtagjs/reference#get
         */
        window.gtag('get', gawConversionID, 'gclid', (gclid) => {
          if (gclid && gclid !== Cookies.get('jerrygclid')) {
            Cookies.set('jerrygclid', gclid);
          }
        });
      }
      // Google Analytics 4 (App + Web property)
      if (gaMeasurementID) {
        window.gaMeasurementID = gaMeasurementID;
      }
      if (gtagID) {
        // GTM already loads this js, so don't call `gtag` to load it again
        // window.gtag('config', gtagID);
        window.gtagID = gtagID;
      }

      const loadGtm = () => loadScript('https://www.googletagmanager.com/gtm.js?id=' + gaOptimizeID, SCRIPT_ID);
      if (loadAfterLoadEvent) {
        window.addEventListener('load', loadGtm);
        return () => {
          window.removeEventListener('load', loadGtm);
        };
      }
      loadGtm();
    }
    // Only run once after loaded
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
